import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

export default function Privacy() {
  return (
    <div>
      <Header />
      <main style={{ padding: 24 }}>
        <h1>Privacy Policy</h1>
        <p>See full policy at /privacy.html. This route provides a SPA version.</p>
      </main>
      <Footer />
    </div>
  );
}
